import { colors } from "../../../../utils"

export const useStyles = () => {
    return {
        styles: {
            container: {
                padding: "32px",
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "column",
                rowGap: "20px",
            },
            title: {
                flexGrow: 4,
                color: colors.lightPrimary
            },
            datagrid: {
                width: "100%",
                backgroundColor: colors.white,
                "& .MuiDataGrid-row.MuiDataGrid-row": {
                    maxHeight: "none !important",

                },
                '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
                    outline: 'none',
                },
                "& .MuiDataGrid-cell": {
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    maxHeight: "none !important",
                    height: "auto !important",
                    whiteSpace: "normal",
                    alignItems: "flex-start", // para alinear arriba si hay multilinea
                    overflow: "visible",
                },
            },
            filter: {
                fontSize: "40px"
            },
            actionContainer: {
                display: "flex",
                alignItems: "center",
                columnGap: "10px"
            },
            header: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%"
            }
        }
    }
}